"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoExpandableToolbar = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const _1 = require(".");
const ContextMenu_1 = require("../../ContextMenu");
const PositionAtPoint_1 = require("../../../utils/popup/PositionAtPoint");
const context_1 = require("../../Popup/context");
const ClickAway_1 = require("../../../utils/ClickAway");
const ToolbarMenuProvider_1 = require("./ToolbarMenuProvider");
const MoveToViewport_1 = require("../../../utils/popup/MoveToViewport");
const AutoExpandableToolbar = (props) => {
    const { more, context, contextMenu = props.menu, ...rest } = props;
    const [point, setPoint] = React.useState(null);
    const pointRef = React.useRef(null);
    pointRef.current = point;
    const wasOpenAtPressDown = React.useRef(false);
    React.useEffect(() => {
        const onPress = () => {
            wasOpenAtPressDown.current = pointRef.current !== null;
        };
        document.addEventListener('mousedown', onPress, true);
        document.addEventListener('touchstart', onPress, true);
        return () => {
            document.removeEventListener('mousedown', onPress, true);
            document.removeEventListener('touchstart', onPress, true);
        };
    }, []);
    const close = React.useCallback(() => setPoint(null), []);
    const handleMoreClick = React.useCallback((event) => {
        if (wasOpenAtPressDown.current)
            return;
        const rect = event.currentTarget.getBoundingClientRect();
        setPoint({ x: rect.left, y: rect.bottom + 4, dx: 1, dy: 1 });
    }, []);
    const popupContextValue = React.useMemo(() => ({ close }), [close]);
    return (React.createElement(React.Fragment, null,
        React.createElement(_1.ToolbarMenu, { ...rest, more: { ...more, onClick: handleMoreClick } }),
        point && (React.createElement(PositionAtPoint_1.PositionAtPoint, { point: point },
            React.createElement(ClickAway_1.ClickAway, { onClickAway: close },
                React.createElement(context_1.context.Provider, { value: popupContextValue },
                    React.createElement(ToolbarMenuProvider_1.ToolbarMenuProvider, { ...rest, more: more },
                        React.createElement(MoveToViewport_1.MoveToViewport, null,
                            React.createElement(ContextMenu_1.ContextMenu, { inset: true, showSearch: true, ...context, menu: contextMenu, onEsc: close })))))))));
};
exports.AutoExpandableToolbar = AutoExpandableToolbar;
